// extracted by mini-css-extract-plugin
export var changeIcon = "_64-4";
export var container = "_64-0";
export var divider = "_64-7";
export var externalLinkIcon = "_64-1";
export var green = "_64-5";
export var helpCircleIcon = "_64-3";
export var iconButton = "_64-2";
export var red = "_64-6";